import { render, staticRenderFns } from "./TaskAdd.vue?vue&type=template&id=caf2b974"
import script from "./TaskAdd.vue?vue&type=script&lang=js"
export * from "./TaskAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports